import { NEWBUILDING_KPN_NEW_ENTERS } from '../../../constants/experiments';
import { IApplicationState } from '../../../types/redux';
import { isAbUseExperimentGroup } from '../../../utils/experiments';

/**
 * TODO: Удалить файл после раскатки эксперимента в CD-167902
 */
export const selectKPNNewEntersExperimentActive = (state: IApplicationState) => {
  const { abUseExperiments } = state;

  return isAbUseExperimentGroup(abUseExperiments, NEWBUILDING_KPN_NEW_ENTERS, 'B');
};
